// import axios from 'axios';
// import router from '@/router';
// import Vue from 'vue';

import { vuexfireMutations, firestoreAction } from 'vuexfire';
import { db, references } from '@/main'

// import { ToastProgrammatic as Toast } from 'buefy'

import { loadStripe } from "@stripe/stripe-js";
import firebase from 'firebase/app';
import 'firebase/firebase-functions'; // call firebase function to get a stripe portal
import 'firebase/auth';


// setup Stripe.js and Elements
// const STRIPE_PUBLISHABLE_KEY = 'pk_test_51HNkFEDMGlkFTafb5xGV5AR9DAvdFLZC56f13Y9af2Nc7A55wbZo5qkuZlQyZYTTU7jPUo7eDjU6nbpH9Xqf69Mv00IxLX6m6k';
const STRIPE_PUBLISHABLE_KEY = 'pk_live_51HNkFEDMGlkFTafb5QfQxyuWJf128w90HeXYCFCI9djbgOghKFw0lgQ0E3on9jHT5229FsaIoiqpiecTPypt8tAn00xdadUWvL';
let stripe; // , elements
async function initStripe() {
  stripe = await loadStripe(STRIPE_PUBLISHABLE_KEY);
  // elements = stripe.elements();
  return;
}
initStripe();


const state = () => ({
  isLoading: false, // fullpage
  isLoadingSmall: false, // not fullpage
  subscription: null, // subscription status
  products: [],
})
const defaultState = { // to reset store at logout
  isLoading: false,
  isLoadingSmall: false,
  subscription: null,
  products: [],
}

const getters = {
  getSubscription(state) {
    if (state.subscription && (state.subscription.length === 0 || state.subscription === [])) {
      return null;
    } else {
      return state.subscription[0]; // always expecting a single subscription per customer
    }
  }
}

const mutations = {
  RESET(state) {
    Object.keys(defaultState).forEach(key => {
      state[key] = defaultState[key];
    });
  },
  SET_LOADING(state, value) {
    state.isLoading = value;
  },
  SET_LOADING_SMALL(state, value) {
    state.isLoadingSmall = value;
  },

  SET_STRIPE_SUBSCRIPTION(state, status) {
    state.subscription = status;
  },
  SET_PRODUCTS(state, products) {
    state.products = products;
  },
  ...vuexfireMutations,
}

const actions = {
  // disable the ability to start a free trial
  disableTrialEligibility: async({ commit }, practice) => {    
    try {
      commit('SET_LOADING_SMALL', true);
      await db.collection(references.user).doc(practice.owner.uid).update({
        'subscription.eligible_for_trial': false
      });
      console.log('trial no longer available');
    } catch(err) {
      alert(err.message);
    } finally {
      commit('SET_LOADING_SMALL', false);
    }
  },
  // check if subscription is active or expired, works for anyone with an account
  fetchStripeStatus: firestoreAction (async({ bindFirestoreRef, commit }, practice) => {
    commit('SET_LOADING_SMALL', true);
    await bindFirestoreRef('subscription',
      db.collection(references.user)
        .doc(practice.owner.uid)
        .collection('subscriptions')
        .where('status', 'in', ['trialing', 'active'])
    )
    commit('SET_LOADING_SMALL', false);
  }),
  // list products
  fetchProducts: async({ commit }) => { 
    commit('SET_LOADING', true);
    db.collection('stripe_products') 
    .where('active', '==', true)
    .get()
    .then((querySnapshot) => {
      let idx = 0;
      let products = [];
      querySnapshot.forEach(async(doc) => {
        products.push({ ...doc.data(), prices: [] });
        const priceSnap = await doc.ref.collection('prices').get();
        priceSnap.docs.forEach((doc) => {
          products[idx].prices.push({ ...doc.data(), id: doc.id });
        });
        idx++;
        if (idx === priceSnap.size) { // .size is firebase equivalent to .length
          commit('SET_PRODUCTS', products);
        }
      });
      commit('SET_LOADING', false);
    });
  },
  // get stripe setup portal link to manage their subsciption, FOR EXISTING CUSTOMERS
  viewSubscription: async ({ commit }) => {
    commit('SET_LOADING', true);
    try {
      const url = window.location.origin.split('/').pop();
      const returnUrl =`https://${url}/account`;
      const functionRef = firebase.app().functions('us-central1').httpsCallable('ext-firestore-stripe-subscriptions-createPortalLink');
      const { data } = await functionRef({ returnUrl });
      // no need to disable loading since this state is not cached, 
      // and this action redirects away from page
      window.location.assign(data.url);
    } catch(err) {
      console.log(err);
      commit('SET_LOADING', false);
    }
  },
  // start a subscription / open a checkout session
  checkout: async ({ commit, rootState }, { price }) => { // removed 'trial' property
    commit('SET_LOADING', true);
    const user = firebase.auth().currentUser;
    const url = window.location.origin.split('/').pop();
    const success_url =`https://${url}/account?msg=stripe_success`;
    const cancel_url =`https://${url}/account?msg=fail`;
    const docRef = await db
      .collection(references.user)
      .doc(user.uid)
      .collection('checkout_sessions')
      .add({ 
        success_url,
        cancel_url, 
        price,
        trial_from_plan: rootState.auth.user.subscription.eligible_for_trial,
        // allow_promotion_codes: true,
        // subscription_data: {
        //   trial_period_days: 30,
        // },
      });
    docRef.onSnapshot((snap) => { // Wait for the CheckoutSession to get attached by the extension
      const { error, sessionId } = snap.data();
      if (error) {
        commit('SET_LOADING', false);
        console.log(error)
        alert(`An error occured: ${error.message}`);
      }
      if (sessionId) { // We have a session, let's redirect to Checkout
        stripe.redirectToCheckout({ sessionId });
        // no need to disable loading since this state is not cached, 
        // and this action redirects away from page
      }
    });
  },

  unbindAllFirestore: firestoreAction(({ unbindFirestoreRef }) => {
    unbindFirestoreRef('subscription')
    sessionStorage.clear();
  }),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}